export default "__VITE_ASSET__D77EbSU0__"